import { Fragment } from "react/jsx-runtime";
import { Col, Row } from "reactstrap";
import { H4 } from "../../../../AbstractElements";
import { SearchPixelStrap } from "../../../../Constants/Constants";
import { SearchInformation, SearchTabData } from "../../../../Data/Applications/SearchResult/SearchResult";
import InformationCommon from "./common/InformationCommon";
import PagesSort from "./Pages";

const AllTabs = () => {
  return (
    <Fragment>
      <H4 className="mb-2">{SearchPixelStrap}</H4>
      <Row>
        <Col xxl="6" xl="6" className="box-col-12">
          {SearchTabData.map((item, i) => (
            <InformationCommon item={item} key={i} />
          ))}
        </Col>
        <Col xxl="6" xl="6" className="box-col-12">
          {SearchInformation.map((item, i) => (
            <InformationCommon item={item} key={i} />
          ))}
        </Col>
      </Row>
      <PagesSort pageClass="end" />
    </Fragment>
  );
};
export default AllTabs;
